import { useEffect, useState } from "react";
import programmingContentService from "app/services/programming-content-service";

const useGetProgrammingContentsForNavigation = (page, size, languageFilter) => {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContents = async () => {
      setLoading(true);
      try {
        const res = await programmingContentService.getProgrammingContents(
          page - 1,
          size,
          languageFilter
        );

        if (res.statusText !== "OK") {
          throw new Error(`Error ${res.status}: ${res.statusText}`);
        }

        const data = res.data;

        const totalCountFromHeader = res.headers
          ? res.headers["x-total-count"]
          : null;

        setContents(data || []);
        setTotalCount(
          totalCountFromHeader ? Number(totalCountFromHeader) : data.length || 0
        );
        setError(null);
      } catch (error) {
        const errorMessage = error.response
          ? `Error ${error.response.status || "Unknown"}: ${
              error.response.statusText || "Unknown"
            }`
          : error.message || "Unknown error occurred";
        setError(errorMessage);
        setContents([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchContents();
  }, [page, size, languageFilter]);

  return { contents, totalCount, error, loading };
};

export default useGetProgrammingContentsForNavigation;
